const RU_UNITS = ["", "один", "два", "три", "четыре", "пять", "шесть", "семь", "восемь", "девять"];
const RU_UNITS_FEM = ["", "одна", "две", "три", "четыре", "пять", "шесть", "семь", "восемь", "девять"];
const RU_TEENS = [
  "десять", "одиннадцать", "двенадцать", "тринадцать", "четырнадцать",
  "пятнадцать", "шестнадцать", "семнадцать", "восемнадцать", "девятнадцать",
];
const RU_TENS = ["", "", "двадцать", "тридцать", "сорок", "пятьдесят", "шестьдесят", "семьдесят", "восемьдесят", "девяносто"];
const RU_HUNDREDS = ["", "сто", "двести", "триста", "четыреста", "пятьсот", "шестьсот", "семьсот", "восемьсот", "девятьсот"];

function ruTripletToWords(n: number, feminine: boolean): string[] {
  const words: string[] = [];
  const hundreds = Math.floor(n / 100);
  const remainder = n % 100;

  if (hundreds > 0) words.push(RU_HUNDREDS[hundreds]);

  if (remainder >= 10 && remainder < 20) {
    words.push(RU_TEENS[remainder - 10]);
  } else {
    const tens = Math.floor(remainder / 10);
    const units = remainder % 10;
    if (tens > 0) words.push(RU_TENS[tens]);
    if (units > 0) words.push((feminine ? RU_UNITS_FEM : RU_UNITS)[units]);
  }

  return words;
}

function ruPluralForm(n: number, forms: [string, string, string]): string {
  const mod100 = n % 100;
  const mod10 = n % 10;
  if (mod100 >= 11 && mod100 <= 14) return forms[2];
  if (mod10 === 1) return forms[0];
  if (mod10 >= 2 && mod10 <= 4) return forms[1];
  return forms[2];
}

function ruIntegerToWords(amount: number): string {
  if (amount === 0) return "ноль";

  const billions = Math.floor(amount / 1_000_000_000);
  const millions = Math.floor((amount % 1_000_000_000) / 1_000_000);
  const thousands = Math.floor((amount % 1_000_000) / 1000);
  const units = amount % 1000;

  const parts: string[] = [];

  if (billions > 0) {
    parts.push(...ruTripletToWords(billions, false));
    parts.push(ruPluralForm(billions, ["миллиард", "миллиарда", "миллиардов"]));
  }
  if (millions > 0) {
    parts.push(...ruTripletToWords(millions, false));
    parts.push(ruPluralForm(millions, ["миллион", "миллиона", "миллионов"]));
  }
  if (thousands > 0) {
    parts.push(...ruTripletToWords(thousands, true));
    parts.push(ruPluralForm(thousands, ["тысяча", "тысячи", "тысяч"]));
  }
  if (units > 0 || parts.length === 0) {
    parts.push(...ruTripletToWords(units, false));
  }

  return parts.join(" ");
}

const KK_UNITS = ["", "бір", "екі", "үш", "төрт", "бес", "алты", "жеті", "сегіз", "тоғыз"];
const KK_TENS = ["", "он", "жиырма", "отыз", "қырық", "елу", "алпыс", "жетпіс", "сексен", "тоқсан"];

function kkTripletToWords(n: number): string[] {
  const words: string[] = [];
  const hundreds = Math.floor(n / 100);
  const remainder = n % 100;
  const tens = Math.floor(remainder / 10);
  const units = remainder % 10;

  if (hundreds > 0) {
    if (hundreds > 1) words.push(KK_UNITS[hundreds]);
    words.push("жүз");
  }
  if (tens > 0) words.push(KK_TENS[tens]);
  if (units > 0) words.push(KK_UNITS[units]);

  return words;
}

function kkIntegerToWords(amount: number): string {
  if (amount === 0) return "нөл";

  const millions = Math.floor(amount / 1_000_000);
  const thousands = Math.floor((amount % 1_000_000) / 1000);
  const parts: string[] = [];

  if (millions > 0) parts.push(...kkTripletToWords(millions), "миллион");
  if (thousands > 0) parts.push(...kkTripletToWords(thousands), "мың");
  parts.push(...kkTripletToWords(amount % 1000));

  return parts.join(" ");
}

export function integerToWords(value: number, locale: "ru" | "kk"): string {
  const whole = Math.trunc(Math.abs(value));
  return locale === "kk" ? kkIntegerToWords(whole) : ruIntegerToWords(whole);
}
